import * as CacheAdapter from 'lru-cache';
import buildURL from 'axios/lib/helpers/buildURL';

let buildSortedURL = function buildSortedURL(...args) {
	const builtURL = buildURL(...args);
	const [urlPath, queryString] = builtURL.split('?');
	if (queryString) {
		const paramsPair = queryString.split('&');
		return `${urlPath}?${paramsPair.sort().join('&')}`;
	}
	return builtURL;
};

const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24;
const CAPACITY = 100;

export function cacheAdapter(adapter, options) {
	const LRUCache = CacheAdapter.LRUCache ?? CacheAdapter;
	const { enabledByDefault = false, cacheFlag = 'cache', defaultCache = new LRUCache({ maxAge: TWENTY_FOUR_HOURS, max: CAPACITY }) } = options;

	return config => {
		const { url, method, params, paramsSerializer, forceUpdate, maxAge } = config;
		const useCache = config[cacheFlag] !== void 0 && config[cacheFlag] !== null ? config[cacheFlag] : enabledByDefault;

		if (method === 'get' && useCache) {
			// if had provide a specified cache, then use it instead
			const cache = defaultCache;

			// build the index according to the url and params
			const index = buildSortedURL(url, params, paramsSerializer);

			let responsePromise = cache.get(index);

			if (!responsePromise || forceUpdate) {
				responsePromise = (async () => {
					try {
						return await adapter(config);
					} catch (reason) {
						cache.delete(index);
						throw reason;
					}
				})();

				// put the promise for the non-transformed response into cache as a placeholder
				cache.set(index, responsePromise, maxAge ? maxAge : TWENTY_FOUR_HOURS);

				return responsePromise;
			}

			console.info(`[axios-extensions] request cached by cache adapter --> url: ${index}`);

			return responsePromise;
		}

		return adapter(config);
	};
}
